
<!-- Modal header -->
<div class="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
    <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{data?.data?.header?.titleDisplayKey | translate}}
    </h3>
    <span (click)="closeModal()" mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
    </span>
</div>
<!-- Modal body -->
<div class="p-6">
    <div
        cdkDropList
        class="task-list border rounded border-gray-300"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListSortPredicate]="sortPredicate.bind(this)">
        <div
            class="task-box text-lg"
            [ngClass]="{
                'bg-gray-100': (disabledTask?.length - 1) >= i
            }"
            *ngFor="let task of tasks; let i = index"
            [cdkDragData]="task"
            cdkDrag
            [cdkDragDisabled]="(disabledTask?.length - 1) >= i"
            >
            <div class="flex w-full" [ngClass]="{'justify-between': task?.service_task_status}">
                <div>
                    <em class="ti ti-grid-dots mr-3 text-2xl" *ngIf="!((disabledTask?.length - 1) >= i)"></em>
                    <span *ngIf="(disabledTask?.length - 1) >= i" class="mr-3">{{i+1}}.</span>
                    {{task?.service_task_title}}
                </div>
                <div>
                    <!-- <span>{{task?.service_task_status}}</span> -->
                    <badge *ngIf="task?.service_task_status" [options]="getBadgeOptions(task)"></badge>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal footer -->
<div class="flex justify-end items-center p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
    <button (click)="closeModal()" type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:outline-none rounded-lg border border-gray-200 text-base font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">{{"close.text" | translate}}</button>
    <button (click)="rearrangeTask()" type="button" class="text-white bg-primary font-medium rounded-lg text-base px-5 py-2.5 text-center">{{"label.reorder" | translate}}</button>
</div>